
import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { catchError, EMPTY, filter, Observable, take } from 'rxjs';
import { VendorStore } from 'src/app/features/common-data/stores/vendor.store';
import { VendorWithDetails } from 'src/app/shared/models/vendor.model';


@Injectable({
  providedIn: 'root',
})
export class VendorResolver implements Resolve<VendorWithDetails> {
    constructor(private vendorStore: VendorStore, private router: Router) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Observable<VendorWithDetails> {
        const idParam = route.paramMap.get('id');
        if (!idParam) {
          // ohne ID zurück zur Liste
          this.router.navigate(['/vendors']);
          return EMPTY;
        }
        const id = Number(idParam);
        return this.vendorStore.loadVendorById(id).pipe(
          catchError(err => {
            // bei Fehler z.B. auf Notfound umleiten
            this.router.navigate(['/notfound']);
            return EMPTY;
          })
        );
      }
    }
  
  
